import ajax from './axios'

export const getpaper = (params) => {
  return ajax.get('/api/v2/hotkeyword/category/keyword/paper?keyword='+params.keyword+'&count='+params.count, )
}

export const getlinechart = (params) => {
    return ajax.get('/api/v2/hotkeyword/category/keyword/line_chart?keyword='+params.keyword, )
}

export const getproject = (params) => {
    let str = '/api/v2/hotkeyword/category/keyword/field_project?keyword='+params.keyword+'&count='+params.count;
    for(let i=0;i<params.fields.length;i++){
        str = str+ '&fields='+ params.fields[i]
    }
    return ajax.get(str)
}



// WEBPACK FOOTER //
// ./src/api/detail.js